/**
 * MasterBookの表示タイプ定数
 */
export const MB_DISPLAY_TYPE = {
  STAMP_CARD: "StampCard",
  STAMP_RALLY: "StampRally",
};
